label
  span(data-hook="label")
  .input-addon
    input(step="any", min=0).input-addon-field
    span.input-addon-item #{addon}
  div(data-hook="message-container").message.message-below
    p(data-hook="message-text")
